import axios from "axios";
import http from "Utils/api2"

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const getAllShiping = createAsyncThunk("getAllShiping", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});
export const getSingleShiping = createAsyncThunk("getSingleTax", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});


export const updateShiping = createAsyncThunk("updatedataShiping", async ({url,data}) => {
    try {
      const res = await axios.put(url,data, {
        headers: {
          authorization: localStorage.getItem("token"),
        }});
      return res.data;
    } catch (error) {
      return { data: null };
    }
  });

const ShipingSlice = createSlice({
  name: "Shiping",
  initialState: {
    Shiping: null,
    singleShiping: null,
    Loading:false,
    updateLoading:false,
    isPages:null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllShiping.pending, (state, action) => {
        state.Loading = true;
      })
      .addCase(getAllShiping.fulfilled, (state, action) => {
        state.Loading = false;
        state.Shiping = action.payload?.data;
        state.isPages = action.payload?.page;
      })
      .addCase(getAllShiping.rejected, (state, action) => {
        state.Loading = false;
      })
      .addCase(getSingleShiping.pending, (state, action) => {
      })
      .addCase(getSingleShiping.fulfilled, (state, action) => {
        state.singleShiping = action.payload?.data;
      })
      .addCase(getSingleShiping.rejected, (state, action) => {
      })
      .addCase(updateShiping.pending, (state, action) => {
        state.updateLoading = true;
      })
      .addCase(updateShiping.fulfilled, (state, action) => {
        state.updateLoading = false;
      
       
      })
      .addCase(updateShiping.rejected, (state, action) => {
        state.updateLoading = false;
      })
  },
});
export default ShipingSlice.reducer;
